module.exports = __webpack_public_path__ + "img/super-whisperer-400_75c19493ea21939f2fabffa1a6ad3961.longcache.png";